import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import * as fromCheckLicense from './reducers/check-license.reducer';
import { EffectsModule } from '@ngrx/effects';
import { CheckLicenseEffects } from './effects/check-license.effects';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('checkLicense', fromCheckLicense.reducer),
    EffectsModule.forFeature([CheckLicenseEffects])
  ]
})
export class CheckLicenseModule { }
